import React from 'react';
var AnalyticsContext = /*#__PURE__*/React.createContext({
  fireAnalyticsEvent: function fireAnalyticsEvent(_event) {
    return null;
  }
});
export default AnalyticsContext;